import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  preferredJobPosition?: string | null
}

const PreferredJobPosition = ({ preferredJobPosition }: Props) => {
  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.job_position.preferred_position')}
      </Text>
      {preferredJobPosition && (
        <Text size="400" weight="medium" color="grey1000">
          {preferredJobPosition}
        </Text>
      )}
      {!preferredJobPosition && (
        <Text size="400" weight="medium" color="grey600">
          {i18n.t('contract_versions.job_position.not_informed')}
        </Text>
      )}
    </Box>
  )
}

export default PreferredJobPosition
